<template>
    <section class="wrap-billet-head" :style="{'background-image': `url('${banner}')`}">
        <div class="row">
            <div class="small-12 medium-8 large-6 medium-centered columns">
                <h2><strong>Inquilino:</strong> <br>
                 Imprima seu boleto aqui</h2>
                <form @submit.prevent.stop="search">
                    <CPFInput v-model="cpf_cnpj" placeholder="Digite seu CPF ou CNPJ para buscar o(s) boleto(s)"  ></CPFInput>
                    <button v-if="verified" class="default-button" type="submit">Buscar <i aria-hidden="true" class="fa fa-search"></i></button>
                    <vue-recaptcha :loadRecaptchaScript="true" size="invisible" :sitekey="recaptcha_key" @verify="verify" @expired="expired" @render="render" @error="onError" ref="recaptcha"></vue-recaptcha>
                </form>
            </div>
        </div>
    </section>
</template>
<script>

import CPFInput from './CPFInput.vue';
import VueRecaptcha from 'vue-recaptcha';

export default {
    props: ['banner', 'recaptcha_key'],
    components: {
        CPFInput,
        'vue-recaptcha':VueRecaptcha
    },
    data() {
        return {
            error: null,
            verified: false,
            cpf_cnpj: '',
        }
    },
    methods: {
        execute() {
            this.$refs.recaptcha.execute();
        },
        search() {
            if (!this.verified) {
                return;
            }
            this.$emit('search', this.cpf_cnpj);
            this.verified = false;
            this.expired();            
        },
        verify() {            
            
            this.verified = true;
        },
        expired() {
            this.$refs.recaptcha.reset();
            this.execute();
        },
        render() {
            //console.log('render',arguments);
            this.$refs.recaptcha.execute();
        },
        onError() {
            console.error('error',arguments);
            this.error = "Não foi possível executar o reCaptcha.";
        }
    },
    computed: {
    },
    watch: {
    }
}
</script>